require('jquery-serializejson')
require('bootstrap')
require('select2')
require('slick-carousel')
require('@fancyapps/fancybox')
require('@fortawesome/fontawesome-pro/js/all')
require('@fortawesome/fontawesome-pro/js/brands')
